import { normalizeEnum, normalizeText } from '../../shared/normalize';
import { CREATOR_PLATFORMS } from '../../shared/platforms';
import {
	CREATOR_PRODUCTS,
	CREATOR_STATUSES,
	type CreatorDetails,
	type CreatorProfile,
	VERIFICATION_STATUSES,
} from '../types';
import type { CreatorDetailsDto, CreatorProfileDto } from './creator-api.types';

function mapCreatorProfileDto(dto: CreatorProfileDto): CreatorProfile | null {
	const id = normalizeText(dto.id);
	const platform = normalizeEnum(dto.platform, CREATOR_PLATFORMS);
	if (!id || !platform) return null;

	return {
		id,
		platform,
		handle: normalizeText(dto.handle),
		displayName: normalizeText(dto.display_name),
		profileUrl: normalizeText(dto.profile_url),
		followerCount: dto.follower_count ?? null,
		verificationStatus:
			normalizeEnum(dto.verification_status, VERIFICATION_STATUSES) ??
			'PENDING',
		addedAt: normalizeText(dto.added_at) || null,
		verifiedAt: normalizeText(dto.verified_at) || null,
	};
}

export function mapCreatorDetailsDto(dto: CreatorDetailsDto): CreatorDetails {
	return {
		status: normalizeEnum(dto.status, CREATOR_STATUSES) ?? 'NOT_APPLIED',
		canApply: dto.can_apply ?? false,
		couponCode: normalizeText(dto.coupon_code),
		payoutHold: dto.payout_hold ?? false,
		rejectionReason: normalizeText(dto.rejection_reason),
		reapplyAfter: dto.reapply_after ?? null,
		profiles: (dto.profiles ?? [])
			.map(mapCreatorProfileDto)
			.filter((profile) => profile !== null),
		products: (dto.coupons ?? [])
			.map((coupon) => normalizeEnum(coupon.product_type, CREATOR_PRODUCTS))
			.filter((product) => product !== null),
	};
}
